<!--
  @description: 创建定时任务组件
  @author: system
  @date: 2026-06-02
  @note: 负责创建和管理定时发送的通知任务
-->
<template>
  <div class="task-create-container">
    <!-- 操作栏 -->
    <div class="header-toolbar">
      <el-button type="primary" size="small" icon="el-icon-plus" v-waves @click="handleAdd">新增定时任务</el-button>
      <div class="search-area">
        <el-select
          v-model="listQuery.appid"
          placeholder="请选择公众号"
          clearable
          filterable
          size="small"
          style="width: 200px; margin-right: 10px;"
        >
          <el-option
            v-for="item in gzhList"
            :key="item.appid"
            :label="item.account_name"
            :value="item.appid"
          ></el-option>
        </el-select>
        <!-- <el-input
          v-model="listQuery.gzh_openid"
          placeholder="请输入公众号openid"
          clearable
          size="small"
          style="width: 200px; margin-right: 10px;"
        ></el-input>-->
        <el-input
          v-model="listQuery.template_name"
          placeholder="请输入消息模版名称"
          clearable
          size="small"
          style="width: 200px; margin-right: 10px;"
        ></el-input>
        <el-button type="primary" @click="getListData" size="small" icon="el-icon-search" v-waves>搜索</el-button>
      </div>
    </div>

    <!-- 表格列表 -->
    <div class="table-container">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <!-- 所属公众号 -->
        <!-- <template slot="appid" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
            arrayByIdToNameStr({
            ArrayData: gzhList,
            ID: row.appid,
            id_key:'appid',
            name_key:'account_name'
            })
            }}
          </el-tag>
        </template>-->

        <!-- 任务名称 -->
        <template slot="task_name" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">{{ row.task_name ? row.task_name : '-' }}</el-tag>
        </template>

        <!-- 公众号openid -->
        <template slot="gzh_openid" slot-scope="{ row }">
          <span class="code-text">{{ row.gzh_openid ? row.gzh_openid : '暂未登录' }}</span>
        </template>

        <!-- 小程序openid -->
        <template slot="xcx_openid" slot-scope="{ row }">
          <span class="code-text">{{ row.xcx_openid ? row.xcx_openid : '暂未登录' }}</span>
        </template>

        <!-- 模版ID -->
        <template
          slot="template_id"
          slot-scope="{ row }"
        >{{ row.template_name ? row.template_name + '(模版ID:' + row.template_id + ')' : '暂无' }}</template>

        <!-- 时间周期 -->
        <template slot="cycle_id" slot-scope="{ row }">
          <el-tag type="warning" effect="plain" size="mini">
            {{
            arrayByIdToNameStr({
            ArrayData: cycleList,
            ID: row.cycle_id,
            id_key:'id',
            name_key:'cycle_name',
            defultStr: '未设置周期'
            })
            }}
          </el-tag>
        </template>

        <!-- 发送状态 -->
        <template slot="status" slot-scope="{ row }">
          <el-tag type="warning" effect="dark" size="mini" v-if="row.status === 0">进行中</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else-if="row.status === 1">任务异常</el-tag>
          <el-tag type="info" effect="dark" size="mini" v-else-if="row.status === 2">已完成</el-tag>
        </template>

        <!-- 操作按钮 -->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button size="mini" type="text" style="color: #F56C6C;" @click="handleDelete(row)">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 新增/编辑定时任务抽屉 -->
    <CommonDrawer
      :visible.sync="dialogFormVisible"
      :title="inputTypeName"
      size="1000px"
      :close-on-click-modal="false"
      @confirm="save"
      @cancel="dialogFormVisible = false"
    >
      <el-form ref="form" :model="dialogForm" label-width="140px" class="drawer-form">
        <el-form-item label="任务名称" required>
          <el-input
            v-model="dialogForm.task_name"
            placeholder="请输入任务名称"
            clearable
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="选择公众号" required>
          <el-select
            v-model="dialogForm.appid"
            placeholder="请选择公众号"
            clearable
            filterable
            style="width:100%"
            @change="changeAppid"
          >
            <el-option
              v-for="item in gzhList"
              :key="item.appid"
              :label="item.account_name"
              :value="item.appid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="消息模版" required>
          <el-select
            v-model="dialogForm.template_id"
            placeholder="请选择消息模版"
            clearable
            filterable
            style="width:100%"
            @change="changeTemplate"
          >
            <el-option
              v-for="(item, index) in templateList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="模版内容" required v-if="dialogForm.template_id">
          <div class="template-fields">
            <div
              v-for="(item, index) in dialogForm.template_msg_list"
              :key="index"
              class="field-row"
            >
              <el-tag type="info" size="mini" class="field-tag">字段中文描述:</el-tag>
              <el-input
                size="mini"
                v-model="item.keyName"
                placeholder="请输入"
                class="field-input"
                disabled
              ></el-input>

              <el-tag type="info" size="mini" class="field-tag">字段英文命名:</el-tag>
              <el-input
                size="mini"
                v-model="item.key"
                placeholder="请输入"
                class="field-input"
                disabled
              ></el-input>

              <el-tag type="success" size="mini" class="field-tag">字段默认值:</el-tag>
              <el-input
                size="mini"
                v-model="item.value"
                placeholder="请输入默认值"
                class="field-value"
                type="textarea"
                :rows="1"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择用户" required>
          <el-select
            v-model="dialogForm.gzh_openid_list"
            placeholder="请先选择公众号，再选择用户（可多选）"
            multiple
            filterable
            clearable
            style="width:100%"
            :disabled="!dialogForm.appid"
          >
            <el-option
              v-for="(item, index) in userList"
              :key="index"
              :label="item.display_name"
              :value="item.gzh_openid"
            >
              <span style="float: left">{{ item.user_name || '未命名' }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px">{{ item.gzh_openid }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="时间周期" required>
          <el-select
            v-model="dialogForm.cycle_id"
            placeholder="请先选择公众号，再选择时间周期"
            clearable
            filterable
            style="width:100%"
            :disabled="!dialogForm.appid"
          >
            <el-option
              v-for="(item, index) in cycleList"
              :key="index"
              :label="item.cycle_name || `周期${item.id}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="任务状态" required>
          <el-select
            v-model="dialogForm.status"
            placeholder="请选择任务状态"
            clearable
            style="width:100%"
          >
            <el-option label="进行中" :value="0"></el-option>
            <el-option label="任务异常" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </CommonDrawer>
  </div>
</template>

<script>
/**
 * @description 创建定时任务组件
 * @component TaskCreate
 * @requires services/sendService/sendTask - 定时任务相关API
 * @requires services/sendService/sendAccount - 公众号相关API
 * @requires services/sendService/sendTemplate - 模版相关API
 */
import { selectApi as selectGzhListApi } from "@/services/sendService/sendAccount";
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi
} from "@/services/sendService/sendTask";
import { selectApi as selectTemplateApi } from "@/services/sendService/sendTemplate";
import { selectApi as selectUserApi } from "@/services/sendService/sendVisitor";
import { selectApi as selectCycleApi } from "@/services/sendService/sendCycle";
import ElTable from "@/components/elTable/index.vue";
import CommonDrawer from "@/components/drawer/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";

export default {
  name: "TaskCreate",
  components: {
    ElTable,
    CommonDrawer
  },
  created() {
    // 组件创建时获取公众号列表、任务列表和所有周期列表
    this.getGzhList();
    this.getListData();
    this.getAllCycleList(); // 获取所有周期用于列表展示
    // 模版、用户列表在选择公众号后加载
  },
  data() {
    return {
      arrayByIdToNameStr,
      // 列表加载状态
      loading: false,
      // 列表查询参数
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        appid: "",
        gzh_openid: "",
        template_name: ""
      },
      // 任务列表数据
      tableData: [],
      // 新增/编辑抽屉可见性
      dialogFormVisible: false,
      // 操作类型名称（新增/修改）
      inputTypeName: "",
      // 新增/编辑表单数据
      dialogForm: {},
      // 消息模版列表
      templateList: [],
      // 公众号列表
      gzhList: [],
      // 用户列表
      userList: [],
      // 周期列表
      cycleList: []
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  methods: {
    /**
     * @description 获取公众号列表
     */
    async getGzhList() {
      const { data, code } = await selectGzhListApi({
        pageNumber: 1,
        pageSize: 100
      });
      if (code === 200) {
        this.gzhList = data;
      }
    },

    /**
     * @description 获取消息模版列表（根据appid筛选）
     */
    async getTemplateData(appid) {
      if (!appid) {
        this.templateList = [];
        return;
      }
      const { data, code } = await selectTemplateApi({
        pageNumber: 1,
        pageSize: 1000,
        appid: appid
      });
      if (code === 200) {
        this.templateList = data.map(item => {
          return {
            ...item,
            name: item.template_name + "(模版ID:" + item.id + ")"
          };
        });
      }
    },

    /**
     * @description 获取用户列表（根据appid筛选）
     */
    async getUserList(appid) {
      if (!appid) {
        this.userList = [];
        return;
      }
      const { data, code } = await selectUserApi({
        pageNumber: 1,
        pageSize: 1000,
        appid: appid
      });
      if (code === 200) {
        this.userList = data.map(item => {
          return {
            ...item,
            display_name: item.user_name
              ? `${item.user_name}(${item.gzh_openid})`
              : item.gzh_openid
          };
        });
      }
    },

    /**
     * @description 获取所有周期列表（用于列表展示）
     */
    async getAllCycleList() {
      const { data, code } = await selectCycleApi({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.cycleList = data;
      }
    },

    /**
     * @description 获取周期列表（根据appid筛选，用于表单编辑）
     */
    async getCycleList(appid) {
      if (!appid) {
        this.cycleList = [];
        return;
      }
      const { data, code } = await selectCycleApi({
        pageNumber: 1,
        pageSize: 1000,
        appid: appid
      });
      if (code === 200) {
        this.cycleList = data;
      }
    },

    /**
     * @description 获取定时任务列表
     */
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.store_id =
        listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /**
     * @description 选择公众号
     * @param {string} appid - 公众号appid
     */
    changeAppid(appid) {
      // 清空依赖公众号的字段
      this.dialogForm.template_id = "";
      this.dialogForm.template_msg_list = [];
      this.dialogForm.gzh_openid_list = [];
      this.dialogForm.cycle_id = "";

      // 重新加载模版、用户和周期列表
      this.getTemplateData(appid);
      this.getUserList(appid);
      this.getCycleList(appid);
    },

    /**
     * @description 选择消息模版
     * @param {number} templateId - 模版ID
     */
    changeTemplate(templateId) {
      const item = this.templateList.find(item => item.id === templateId);
      if (item) {
        try {
          this.dialogForm.template_msg_list = JSON.parse(
            item.template_msg_list
          );
        } catch (error) {
          this.dialogForm.template_msg_list = [];
        }
      }
    },

    /**
     * @description 页码改变事件
     * @param {number} pageNumber - 新的页码
     */
    handleCurrentChange(pageNumber) {
      this.listQuery.pageNumber = pageNumber;
      this.getListData();
    },

    /**
     * @description 每页条数改变事件
     * @param {number} pageSize - 新的每页条数
     */
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getListData();
    },

    /**
     * @description 新增定时任务
     */
    handleAdd() {
      this.dialogFormVisible = true;
      this.inputTypeName = "新增定时任务";
      this.dialogForm = {
        task_name: "",
        appid: "",
        template_id: "",
        template_msg_list: [],
        template_msg: {},
        gzh_openid_list: [],
        cycle_id: "",
        status: 0
      };
      // 清空模版和用户列表，保留周期列表用于列表展示
      this.templateList = [];
      this.userList = [];
      // 重新加载所有周期列表
      this.getAllCycleList();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 编辑定时任务
     * @param {Object} row - 任务数据
     */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inputTypeName = "修改定时任务";
      this.dialogForm = JSON.parse(JSON.stringify(row));

      // 解析模版字段
      try {
        this.dialogForm.template_msg_list = JSON.parse(
          this.dialogForm.template_msg_list
        );
        this.dialogForm.template_msg_a = JSON.parse(
          this.dialogForm.template_msg_a
        );
      } catch (error) {
        this.dialogForm.template_msg_a = null;
      }

      // 回填模版字段值
      if (this.dialogForm.template_msg_a) {
        this.dialogForm.template_msg_list = this.dialogForm.template_msg_list.map(
          item => {
            if (this.dialogForm.template_msg_a?.[item.key]?.value) {
              item.value = this.dialogForm.template_msg_a[item.key]?.value;
            }
            return item;
          }
        );
      }

      // 处理多选用户（将逗号分隔的字符串转为数组）
      // 使用 $set 确保响应式更新
      const openidList = this.dialogForm.gzh_openid
        ? this.dialogForm.gzh_openid.split(",")
        : [];
      this.$set(this.dialogForm, "gzh_openid_list", openidList);

      // 确保appid字段存在
      if (!this.dialogForm.appid) {
        // 如果没有appid，尝试从account_id查找
        if (this.dialogForm.account_id) {
          const gzh = this.gzhList.find(
            item => item.id === this.dialogForm.account_id
          );
          if (gzh && gzh.appid) {
            this.$set(this.dialogForm, "appid", gzh.appid);
          } else {
            this.$set(this.dialogForm, "appid", "");
          }
        } else {
          this.$set(this.dialogForm, "appid", "");
        }
      }

      // 如果有appid，加载对应的模版、用户和周期列表
      if (this.dialogForm.appid) {
        this.getTemplateData(this.dialogForm.appid);
        this.getUserList(this.dialogForm.appid);
        this.getCycleList(this.dialogForm.appid);
      }

      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 将字段数组转化为公众号模版格式的对象
     * @param {Array} array - 字段数组
     * @returns {Object} 转换后的对象
     */
    transformArrayToObject(array) {
      let transformed = {};
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const { key, value } = item;
        transformed[key] = { value };
      }
      return transformed;
    },

    /**
     * @description 保存定时任务（新增或修改）
     */
    save() {
      let formData = JSON.parse(JSON.stringify(this.dialogForm));

      // 校验任务名称
      if (!formData.task_name || !formData.task_name.trim()) {
        this.$message.error("请输入任务名称");
        return;
      }

      // 校验公众号
      if (!formData.appid) {
        this.$message.error("请选择公众号");
        return;
      }

      // 校验模版字段
      for (let i = 0; i < formData.template_msg_list.length; i++) {
        const item = formData.template_msg_list[i];
        if (!item.keyName || !item.key || !item.value) {
          this.$message.error("请完善模版字段");
          return;
        }
      }

      // 必填字段校验
      if (!formData.gzh_openid_list || formData.gzh_openid_list.length === 0) {
        this.$message.error("请至少选择一个用户");
        return;
      }

      if (!formData.template_id) {
        this.$message.error("请选择消息模版");
        return;
      }

      if (!formData.cycle_id) {
        this.$message.error("请选择时间周期");
        return;
      }

      // 将用户列表转为逗号分隔的字符串
      formData.gzh_openid = formData.gzh_openid_list.join(",");

      // 转换模版字段格式
      try {
        formData.template_msg = JSON.stringify(
          this.transformArrayToObject(formData.template_msg_list)
        );
      } catch (error) {
        formData.template_msg = null;
      }

      if (this.inputTypeName === "新增定时任务") {
        // 新增定时任务
        addApi({
          task_name: formData.task_name,
          appid: formData.appid,
          gzh_openid: formData.gzh_openid,
          template_id: formData.template_id,
          xcx_openid: formData.xcx_openid || "",
          template_msg: formData.template_msg,
          cycle_id: formData.cycle_id,
          status: formData.status
        }).then(res => {
          if (res.code === 200) {
            this.$message.success("新增成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      } else {
        // 修改定时任务
        updateApi({
          id: formData.id,
          task_name: formData.task_name,
          appid: formData.appid,
          gzh_openid: formData.gzh_openid,
          template_id: formData.template_id,
          xcx_openid: formData.xcx_openid || "",
          template_msg: formData.template_msg,
          cycle_id: formData.cycle_id,
          status: formData.status
        }).then(res => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /**
     * @description 删除定时任务
     * @param {Object} row - 任务数据
     */
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该通知任务, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.getListData();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.task-create-container {
  padding: 20px 0;
  min-height: calc(100vh - 150px);

  // 头部工具栏
  .header-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 15px;

    .el-button--primary {
      background-color: #165dff;
      border-color: #165dff;

      &:hover,
      &:focus {
        background-color: #4080ff;
        border-color: #4080ff;
      }
    }

    .search-area {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;

      > * {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }

  // 表格容器
  .table-container {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    min-height: calc(100vh - 300px);

    /deep/ .el-table__empty-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
      width: 100% !important;

      .el-table__empty-text {
        text-align: center;
        line-height: 1.6;
      }
    }

    .code-text {
      font-family: "Courier New", monospace;
      font-size: 13px;
      color: #666;
    }

    .operation {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
  }

  // 抽屉表单
  .drawer-form {
    padding: 20px 0;

    .template-fields {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 20px;
      background: #f5f7fa;

      .field-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 15px;
        gap: 10px;
        flex-wrap: wrap;

        &:last-child {
          margin-bottom: 0;
        }

        .field-tag {
          flex-shrink: 0;
          margin-top: 5px;
        }

        .field-input {
          width: 180px;
        }

        .field-value {
          flex: 1;
          min-width: 250px;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .task-create-container {
    .header-toolbar {
      flex-direction: column;
      align-items: stretch;

      .search-area {
        width: 100%;

        > * {
          width: 100% !important;
        }
      }
    }

    .drawer-form {
      .template-fields {
        padding: 15px;

        .field-row {
          flex-direction: column;

          .field-input,
          .field-value {
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
